import { render, staticRenderFns } from "./LeavingOverlay.vue?vue&type=template&id=2216ecb2&scoped=true&"
import script from "./LeavingOverlay.vue?vue&type=script&lang=js&"
export * from "./LeavingOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LeavingOverlay.vue?vue&type=style&index=0&id=2216ecb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2216ecb2",
  null
  
)

export default component.exports